// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logo":"Header_logo__shVBB","menu":"Header_menu__iSxy+","menuItem":"Header_menuItem__7PxyK"};